import * as api from "@/api/williams/contractors";
import { Contractor } from "@/api/williams/contractors";
import { queryKeys } from "../../queryKeys";
import { routes } from "../../routes";
import { useMutation, useQueryClient } from "react-query";
import { usePinContractor } from "./usePinContractor";

export function useSaveContractor() {
  const queryClient = useQueryClient();
  const pinContractor = usePinContractor();

  return useMutation(async (contractor: Contractor) => {
    const updatedContractor = await api.saveContractor(contractor);

    queryClient.setQueryData(queryKeys.contractor.single(updatedContractor.id), updatedContractor);
    queryClient.invalidateQueries(queryKeys.contractor.list());

    if (window.location.href.endsWith(routes.contractor.create)) {
      // Automatically add new contractors to favorites.
      pinContractor.mutate(updatedContractor.id);
    }

    return updatedContractor;
  });
}
